var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasType)?_c('div',[_vm._v(" "+_vm._s(_vm.type.libelle)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }